import React from 'react';
import {useParams} from 'react-router-dom';

import { useGetProvidersQuery } from '../../redux/services/providerApi';
import LoadingScreen from '../../components/common/LoadingScreen';
import LeadEventSignupScreen from '../../components/leads/LeadEventSignupScreen';

const LeadEventSignupPage = () => {
  const {providerId, eventType} = useParams();
  const providerQuery = useGetProvidersQuery({id: providerId}, {skip: !providerId});
  const provider = providerQuery?.data?.[0];
  console.log('LeadEventSignupPage provider', providerQuery);
  if (!providerQuery.data) <LoadingScreen />;
  return (
    <LeadEventSignupScreen 
      eventType={eventType} 
      providerId={providerId}
      provider={provider}
    />
  );
};

export default LeadEventSignupPage;